import { HTMLAttributes } from 'react';
import { generateTestId } from './data';
import clsx from 'clsx';

const colorClasses = {
  inherit: 'stroke-current',
  primary: 'stroke-primary-600',
  secondary: 'stroke-secondary-500',
  textPrimary: 'stroke-black',
  textSecondary: 'stroke-gray-500',
  accent: 'stroke-white',
  success: 'stroke-success-500',
  error: 'stroke-error-500',
};

export interface CircularProgressProps extends HTMLAttributes<SVGElement> {
  dataTestId?: string;
  color?: keyof typeof colorClasses;
  strokeWidth?: number;
}

const CircularProgress = (props: CircularProgressProps) => {
  const { dataTestId, color = 'inherit', strokeWidth = 2, className, ...rest } = props;

  const testIds = generateTestId(dataTestId || 'circular-progress');

  const commonProps = {
    cx: '12',
    cy: '12',
    r: 12 - strokeWidth / 2,
    className: colorClasses[color],
    strokeWidth: strokeWidth,
    fill: 'transparent',
  };

  return (
    <svg data-testid={testIds.component} {...rest} className={clsx('animate-spin', className)} viewBox='0 0 24 24'>
      <circle {...commonProps} opacity={0.3} />
      <circle {...commonProps} strokeLinecap='butt' strokeDasharray={`${(2 * Math.PI * commonProps.r) / 5} 999999`} />
    </svg>
  );
};

export default CircularProgress;
